export const DEPOT_SELECT = "DEPOT-SELECT";
export const SEARCH = "SEARCH";
export const SELECT_PLAN = "SELECT-PLAN";
export const SELECT_TYPE = "SELECT-TYPE";
export const SELECT_VOLUME_OVERLAY = "SELECT-VOLUME-OVERLAY";
export const APPLY_VOLUME_OVERLAY = "APPLY-VOLUME-OVERLAY";
export const EDIT_PLAN = "EDIT-PLAN";
export const COPY_PLAN = "COPY-PLAN";
export const DAY_PLAN = "DAY-PLAN";
export const DATED_PLAN = "DATED-PLAN";
export const TEMPLATE = "TEMPLATE";
export const APPLY_PLAN = "APPLY-PLAN";
export const CREATE_DATED_PLAN = "CREATE-DATED-PLAN";
export const CREATE_TEMPLATE = "CREATE-TEMPLATE";

export const COPY_BUTTON_ACTION = "COPY_BUTTON_ACTION";
export const CREATE_DATED_PLAN_BACK_ACTION = "CREATE_DATED_PLAN_BACK_ACTION";
export const CREATE_DATED_PLAN_NEXT_ACTION = "CREATE_DATED_PLAN_NEXT_ACTION";
export const CREATE_DATED_PLAN_SAVE_ACTION = "CREATE_DATED_PLAN_SAVE_ACTION";
export const CREATE_TEMPLATE_BACK_ACTION = "CREATE_TEMPLATE_BACK_ACTION";
export const CREATE_TEMPLATE_NEXT_ACTION = "CREATE_TEMPLATE_NEXT_ACTION";
export const CREATE_TEMPLATE_SAVE_ACTION = "CREATE_TEMPLATE_SAVE_ACTION";
export const DELETE_PLAN_ACTION = "DELETE_PLAN_ACTION";
export const RENAME_PLAN_ACTION = "RENAME_PLAN_ACTION";

export const ROUTES = "ROUTES--CARDS";
export const ALLOCATED_ROUTES = "ALLOCATED-ROUTES";
export const UNALLOCATED_ROUTES = "UNALLOCATED-ROUTES";
export const ALL_ROUTES = "ALL-ROUTES";
export const ROUTE_CARD = "ROUTE-CARD";
export const POSTCODE_CARD = "POSTCODE-CARD";

export const SECTIONS = "SECTIONS--CARDS";
export const SHIFT_MANAGERS = "SHIFT_MANAGERS--CARDS";

export const LOCATIONS = "LOCATIONS--CARDS";
export const WAVES = "WAVES--CARDS";
export const PLANNED = "PLANNED--CARDS";
export const SAME_DAY = "SAME_DAY--CARDS";
export const OVERRIDES = "OVERRIDES--CARDS";

export const DRIVERS_PROFILES = "DRIVERS_PROFILES--CARDS";
export const DRIVERS_SCHEDULES = "DRIVERS_SCHEDULES--CARDS";

export const OPTION = "OPTION";
export const MENU_ITEM = "MENU-ITEM";
export const SVG = "SVG";

export const FINAL_ROUTES = "FINAL_ROUTES";
export const COLLECTIONS = "COLLECTIONS";
export const HEATMAP = "HEATMAP";
export const TIMEBAR = "TIMEBAR";

export const COLLECTION_BAR_EDIT_TIMES = "COLLECTION-BAR-EDIT-TIMES";
export const COLLECTION_BAR_DEFAULTS_CHECKBOX =
  "COLLECTION-BAR-DEFAULTS-CHECKBOX";
export const COLLECTION_MAP_LEGEND_ICON = "COLLECTION-MAP-LEGEND-INFO-ICON";
export const COLLECTION_MAP_LEGEND_CLOSE = "COLLECTION-MAP-LEGEND-CLOSE";
